import { createMintSocketBuilder } from '@mint-lib/api-zod-support/socket';

import {
  AuthenticatePayloadSchema,
  ListUpdateSchema,
  MessagePayloadSchema,
  SendListPayloadSchema,
} from './schemas.js';

export const SOCKET_PATH = '/api/recommendations/list/ws' as const;

export const URL = globalThis.location.port
  ? `ws://${globalThis.location.hostname}:${globalThis.location.port}`
  : 'wss://' + globalThis.location.hostname;

export const POLL_INTERVAL_IN_SECONDS = 10;

export const RECO_TOPICS = {
  recommendationList: 'recommendation_list',
  recommendationsUpdate: 'recommendations_update',
  error: 'error',
  connect: 'connect',
  authenticated: 'authenticated',
  authenticate: 'authenticate',
};

export const socket = createMintSocketBuilder({
  onValidationError: (error) => {
    if (import.meta.env.DEV) {
      console.error('[recommendationSocket] invalid message', error);
    }
  },
});

export const sendAuthenticate = socket.defineSend({
  topic: RECO_TOPICS.authenticate,
  payloadSchema: AuthenticatePayloadSchema,
});

export const sendList = socket.defineSend({
  topic: RECO_TOPICS.recommendationList,
  payloadSchema: SendListPayloadSchema,
});

export const onAuthenticated = socket.defineSubscribe({
  topic: RECO_TOPICS.authenticated,
  payloadSchema: MessagePayloadSchema,
});

export const onListUpdate = socket.defineSubscribe({
  topic: RECO_TOPICS.recommendationsUpdate,
  payloadSchema: ListUpdateSchema,
});

export const onError = socket.defineSubscribe({
  topic: RECO_TOPICS.error,
  payloadSchema: MessagePayloadSchema,
});
